const ImageCacheMap = {}

export const help = {
  methods: {
    getMaxSupportWidth() {
      return window.innerHeight / window.innerWidth <= 667 / 375
        ? (window.innerHeight * 375) / 667
        : 600
    },
    transformWH(u) {
      const MaxSupportWidth = this.getMaxSupportWidth()
      const width =
        window.innerWidth > MaxSupportWidth
          ? MaxSupportWidth
          : window.innerWidth

      return (u / 750) * width
    },
    async getImage(src) {
      if (ImageCacheMap[src]) {
        return Promise.resolve(ImageCacheMap[src])
      }

      const image = new Image()
      image.src = src
      return new Promise((resovle, reject) => {
        image.onload = () => {
          ImageCacheMap[src] = image
          resovle(image)
        }
        image.onerror = err => {
          reject(err)
        }
      })
    },
    async placeImage(src, configName, updateWH = true) {
      const img = await this.getImage(src)
      if (updateWH) {
        const width = this.transformWH(img.width)
        const height = this.transformWH(img.height)
        this[configName] = {
          ...this[configName],
          image: img,
          width,
          height
        }
      } else {
        this[configName] = {
          ...this[configName],
          image: img
        }
      }
    },
    async tryExist(conditionCB, executeCB) {
      const timer = setInterval(async() => {
        try {
          if (await conditionCB()) {
            clearInterval(timer)
            await executeCB()
          }
        } catch (error) {
          console.error(error)
          clearInterval(timer)
        }
      }, 100)
    },
    async tryExistPromise(conditionCB) {
      return new Promise((resolve, reject) => {
        const timer = setInterval(async() => {
          try {
            if (await conditionCB()) {
              resolve()
              clearInterval(timer)
            }
          } catch (error) {
            reject(error)
            clearInterval(timer)
          }
        }, 100)
      })
    }
  }
}
